import * as React from "react";

import { createHocDisplayName } from "./TypingUtils";
import { UnitId } from "./FormParts/Unit/UnitId/UnitId";
import { useInstancesStack } from "./Internals/ControlContexts/PathContexts/PushInstance";

export interface UnitIdResolver {
    (unitId: UnitId): UnitId;
    (unitId: UnitId | undefined): UnitId | undefined;
}

export interface TargetProps {
    resolveUnitId?: UnitIdResolver;
}

export function withResolveUnitId<P>(Component: React.ComponentType<P>): React.ComponentClass<Omit<P, "resolveUnitId">>;
export function withResolveUnitId<P extends TargetProps>(Component: React.ComponentType<P>): React.ComponentType<P> {
    function ResolvePaths(props: P): JSX.Element {
        const instancesStack = useInstancesStack();
        const resolveUnitId = React.useCallback(
            (unitId: UnitId | undefined): UnitId | undefined => {
                if (unitId == undefined) {
                    return undefined;
                }
                if (instancesStack.length === 0) {
                    return unitId;
                }
                return {
                    ...unitId,
                    parentInstances: instancesStack.map(x => x.instance),
                    instancesStack: instancesStack,
                };
            },
            [instancesStack]
        );
        return <Component {...props} resolveUnitId={resolveUnitId} />;
    }
    ResolvePaths.displayName = createHocDisplayName(Component, "ResolveUnitId");
    return ResolvePaths;
}
